<div>
  <loadable class="rv-grid large" [data]="_.accountCountsLoadable">
    <time-series
      [data]="_.timeSeries"
      [minDate]="_.startDate"
      [maxDate]="_.endDate"
      [calculateValue]="_.timeSeriesCalculateValue"
      [valueFormatter]="_.timeSeriesValueFormatter"
      [legend]="true"
    ></time-series>

    <div class="mb-small mx-xlarge">
      <div class="rv-left">
        <h3>
          {{ showingDetail ? 'Hide' : 'Show' }} chart data
          <button
            rivButton
            [variant]="'ghost'"
            [size]="'xsmall'"
            (click)="showingDetail = !showingDetail"
            [icon]="!showingDetail ? 'ChevronDown' : 'ChevronUp'"
          ></button>
        </h3>
      </div>
      <div [hidden]="!showingDetail">
        <table class="rv-table super-border">
          <thead>
            <tr>
              <th class="rv-left">Date</th>
              <th class="rv-right">835 Count</th>
              <th class="rv-right">837 Count</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of shapeWeeklyData(_.accountCountsLoadable)">
              <td>
                <div truncate class="rv-left">{{ entry.date }}</div>
              </td>
              <td>
                <div truncate class="rv-right">{{ entry.count835 }}</div>
              </td>
              <td>
                <div truncate class="rv-right">{{ entry.count837 }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </loadable>
</div>
